import getConfig from 'next/config';

import {getApiRequest, patchApiRequest} from '~/src/utilities/feed/api.js';
import UserProfileModel from '~/src/models/UserProfile';
import {login, userIsLoggedIn} from '~/src/utilities/helpers/account';
import {refreshOrShouldLogin} from '~/src/utilities/helpers/login';
import {Logger} from '~/src/utilities/helpers/log';

const {publicRuntimeConfig: config} = getConfig();

const getUserProfileDefaultConfig = {
    forceLogin: true
};

type GetUserProfile = (configOverrides?: Partial<typeof getUserProfileDefaultConfig>) => Promise<UserProfileModel | void>;
const getUserProfile: GetUserProfile = async (configOverrides = {}) => {
    const {forceLogin} = {
        ...getUserProfileDefaultConfig,
        ...configOverrides
    };

    if (forceLogin) {
        const isLoggedIn = userIsLoggedIn();
        if (!isLoggedIn || (await refreshOrShouldLogin(isLoggedIn))) {
            return login();
        }
    }

    try {
        return await getApiRequest(config.feeds.profile);
    } catch (error) {
        Logger.info(`[${error.name}][Profile] Error while retrieving user profile`, {error});
        throw error;
    }
};

const updateUserProfile = async (profile: UserProfileModel): Promise<any | void> => {
    const isLoggedIn = userIsLoggedIn();
    if (!isLoggedIn || (await refreshOrShouldLogin(isLoggedIn))) {
        return login();
    }

    try {
        await patchApiRequest(`${config.feeds.profile}?tenantId=${config.tenantId}`, {...profile, email: undefined});
    } catch (error) {
        if (error.statusCode === 422) {
            return await error.raw.json();
        }

        Logger.info(`[${error.name}][Profile] Error while updating user profile`, {error});
        throw error;
    }
};

export {getUserProfile, updateUserProfile};
